import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import authService from '../../redux/auth/auth.service';

const StyledActionBox = ({ text, actionText, onClick }) => {
  const theme = useTheme();

  return (
    <Box
      onClick={onClick}
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '16px 20px',
        width: 'calc(100% - 40px)',
        maxWidth: '360px',
        margin: '8px 0',
        backgroundColor: theme.palette.grey[200],
        cursor: 'pointer',
        transition: 'all 0.3s ease-in-out',
        '&:hover': {
          width: '100%',
          backgroundColor: '#F6E0D4',
          '& .mainText, & .arrowIcon': {
            color: theme.palette.accent.main
          }
        }
      }}>
      <Typography
        variant="body1"
        className="mainText"
        sx={{
          fontWeight: 1000,
          color: theme.palette.text.primary
        }}>
        {text}
      </Typography>

      <Box display="flex" alignItems="center" className="arrowIcon">
        <Typography
          variant="body1"
          sx={{
            display: 'flex',
            alignItems: 'center',
            color: theme.palette.text.primary,
            transition: 'color 0.3s'
          }}>
          {actionText} <ArrowForwardIosIcon fontSize="small" sx={{ ml: 0.5 }} />
        </Typography>
      </Box>
    </Box>
  );
};

const Welcome = () => {
  const navigate = useNavigate();

  const login = async () => {
    try {
      // Get authorization URL from backend
      const url = await authService.login();

      // Redirect browser to DataView login page (avoids CORS)
      window.location.href = url;
    } catch (err) {
      console.error('Login failed', err);
    }
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      sx={{
        width: '100%',
        mx: 'auto',
        mt: 6,
        p: 2
      }}>
      <Typography
        variant="h6"
        gutterBottom
        color="accent"
        sx={{
          fontSize: '14px',
          fontWeight: 'bold',
          letterSpacing: '0.1em'
        }}>
        LOG IN TO YOUR SECURE ACCOUNT
      </Typography>

      <Typography variant="headingText" gutterBottom sx={{ fontSize: '3.5em' }}>
        Welcome.
      </Typography>

      <StyledActionBox
        text="Already Registered?"
        actionText="Log In"
        onClick={login} // <-- redirect handled here
      />

      <StyledActionBox
        text="Not Registered?"
        actionText="Sign Up"
        onClick={() => navigate('/signup/select')}
      />
    </Box>
  );
};

export default Welcome;
